import { useState } from "react";

import AddAddressModal from "./AddAddressModal";
import "./AddressSection.css";

function AddressSection({

  addresses = [],

  selectedAddress,

  setSelectedAddress,

  refreshAddresses

}) {

  const [showModal, setShowModal] = useState(false);


  // =========================================================
  // GET ADDRESS ID
  // Supports both MongoDB _id and normal id
  // =========================================================

  const getAddressId = (address) => {

    if (!address) {
      return null;
    }

    return address._id || address.id || null;

  };


  // =========================================================
  // SELECTED ADDRESS
  // =========================================================

  const selected =

    addresses.find(

      (address) =>

        String(
          getAddressId(address)
        ) === String(
          selectedAddress
        )

    ) || addresses[0] || null;


  // =========================================================
  // ADDRESS DISPLAY
  // =========================================================

  const formatAddress = (address) => {

    if (!address) {
      return "";
    }

    return [

      address.houseNo,

      address.apartment,

      address.street,

      address.landmark,

      address.area,

      address.city,

      address.district,

      address.state,

      address.pincode

    ]

      .filter(Boolean)

      .join(", ");

  };


  return (

    <>

      <section className="address-section-card">

        {/* =================================================
            HEADER
        ================================================= */}

        <div className="address-section-header">

          <div className="address-section-title">

            <div className="address-section-icon">

              📍

            </div>

            <div>

              <h2>

                Delivery Address

              </h2>

              <p>

                Choose where your order should be delivered.

              </p>

            </div>

          </div>


          <div className="address-count">

            {addresses.length} Saved

          </div>

        </div>


        {/* =================================================
            NO SAVED ADDRESS
        ================================================= */}

        {addresses.length === 0 ? (

          <button

            type="button"

            className="add-address-box"

            onClick={() =>

              setShowModal(true)

            }

          >

            <div className="add-address-icon">

              +

            </div>


            <div className="add-address-content">

              <h3>

                Add Delivery Address

              </h3>

              <p>

                Save your Home, Work or Other address.

              </p>

            </div>


            <span className="add-address-arrow">

              →

            </span>

          </button>

        ) : (

          <>

            {/* =================================================
                SELECTED ADDRESS
            ================================================= */}

            <div className="selected-address-card">

              <div className="selected-address-main">

                <div className="selected-address-top">

                  <span className="selected-address-type">

                    {selected?.addressType || "Home"}

                  </span>


                  <span className="selected-address-name">

                    {selected?.fullName || "Delivery Address"}

                  </span>

                </div>


                <div className="selected-address-text">

                  {formatAddress(selected)}

                </div>


                {selected?.phone && (

                  <div className="selected-address-phone">

                    📞 {selected.phone}

                  </div>

                )}

              </div>


              <button

                type="button"

                className="change-address-btn"

                onClick={() =>

                  setShowModal(true)

                }

              >

                Change

              </button>

            </div>


            {/* =================================================
                SAVED ADDRESS LIST
            ================================================= */}

            <div className="address-dropdown">

              <div className="address-dropdown-title">

                <span>

                  Saved Addresses

                </span>

                <span>

                  {addresses.length}

                </span>

              </div>


              <div className="address-list">

                {addresses.map(

                  (address) => {

                    const addressId =
                      getAddressId(address);


                    const isActive =

                      String(
                        selectedAddress
                      ) === String(
                        addressId
                      );


                    return (

                      <button

                        type="button"

                        key={addressId}

                        className={

                          isActive

                            ? "address-dropdown-item active"

                            : "address-dropdown-item"

                        }

                        onClick={() =>

                          setSelectedAddress(
                            addressId
                          )

                        }

                      >

                        <div className="dropdown-left">

                          <div className="dropdown-name">

                            <span className="dropdown-type-icon">

                              {address.addressType ===
                              "Work"

                                ? "🏢"

                                : address.addressType ===
                                  "Other"

                                  ? "📍"

                                  : "🏠"}

                            </span>

                            <span>

                              {address.addressType ||
                                "Home"}

                            </span>

                          </div>


                          <div className="dropdown-address">

                            {formatAddress(address)}

                          </div>

                        </div>


                        <div className="dropdown-check">

                          {isActive ? "✓" : ""}

                        </div>

                      </button>

                    );

                  }

                )}

              </div>


              {/* =================================================
                  ADD NEW ADDRESS
              ================================================= */}

              <button

                type="button"

                className="add-new-address-row"

                onClick={() =>

                  setShowModal(true)

                }

              >

                <span className="add-new-icon">

                  +

                </span>

                <span>

                  Add New Address

                </span>

                <span className="add-new-arrow">

                  →

                </span>

              </button>

            </div>

          </>

        )}

      </section>


      {/* =================================================
          ADD ADDRESS MODAL
      ================================================= */}

      {showModal && (

        <AddAddressModal

          closeModal={() =>

            setShowModal(false)

          }

          refreshAddresses={

            refreshAddresses

          }

        />

      )}

    </>

  );

}


export default AddressSection;